"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.asyncPipe = void 0;
var Evt_2 = require("./Evt");
/**
 * NOTE: Workaround until v2.0 where .pipe() will support async operators
 * Usage example: https://stackblitz.com/edit/evt-async-op?file=index.ts
 *
 * When the argument is a StatefulEvt:
 * If, wile asyncOp was running, the state of the source evt
 * have changed then the result will be discarded.
 *
 * If the asyncOp complete synchronously (meaning it does not return
 * a promise) then the result is synchronously transformed. (As with .pipe() )
 *
 * More usage example in src/test/test95.ts
 */
function asyncPipe(evt, asyncOp) {
    var _this_1 = this;
    var out = "state" in evt ?
        Evt_2.Evt.create(undefined) :
        Evt_2.Evt.create();
    var currentCallCount = 0;
    evt.attach(function (data) { return __awaiter(_this_1, void 0, void 0, function () {
        var thisCallCount, prOpResult, opResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentCallCount++;
                    thisCallCount = currentCallCount;
                    prOpResult = asyncOp(data);
                    if (!(prOpResult !== null &&
                        "then" in prOpResult)) return [3 /*break*/, 2];
                    return [4 /*yield*/, prOpResult];
                case 1:
                    opResult = _a.sent();
                    if ("state" in evt &&
                        thisCallCount !== currentCallCount) {
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    opResult = prOpResult;
                    _a.label = 3;
                case 3:
                    if (opResult === null) {
                        return [2 /*return*/];
                    }
                    out.post(opResult[0]);
                    return [2 /*return*/];
            }
        });
    }); });
    return out;
}
exports.asyncPipe = asyncPipe;
//# sourceMappingURL=Evt.asyncPipe.js.map